import {
  AppBar,
  Box,
  Button,
  Dialog,
  IconButton,
  Slide,
  Stack,
  Toolbar,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import AppBarCustom from "../component/AppBar";
import styled from "@emotion/styled";
import TableCustom from "../component/tableCustom";
import {
  AddRounded,
  CloseRounded,
  DeleteRounded,
  EditRounded,
  SearchRounded,
  UploadRounded,
} from "@mui/icons-material";
import react from "react";
import DetailDialog from "../component/DetailDialog";
import Api from "../api/RestApi.json";
import { useNavigate } from "react-router-dom";
import React from "react";
import axios from "axios";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),

  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

export default function DaerahPage(params) {
  const theme = useTheme();
  const goTo = useNavigate();
  const [deleteStatus, setDeleteStatus] = React.useState(null);

  const row = params.data.filter((item) => item.kategori == "Kecamatan");
  const file = params.file;

  const deletePost = async (dataUpdate) => {
    setDeleteStatus(null);
    const data = {
      id: dataUpdate.id,
      kategori: dataUpdate.kategori,
      judul: dataUpdate.judul,
      penulis: "-",
      deskripsi: "-",
    };

    try {
      var response = "";
      response = await axios.put(Api.artikel + "/" + data.id, data);
      if (response !== "") {
        setDeleteStatus("Artikel pada data-" + data.id + " Berhasil dihapus");
      }
    } catch (error) {
      console.error("Error delete file:", error);
      setDeleteStatus("File gagal dihapus. Tolong Muat Ulang Halaman.");
    }

    const profil = file.filter(
      (item) => item.kategori == "Profil" && item.id_foreign == data.id
    )[0];

    if (profil) {
      try {
        var deleteFile = "";
        deleteFile = await axios.delete(Api.file + "/" + profil.id);
      } catch (error) {}
    }
    const gambar = file.filter(
      (item) => item.kategori == "Gambar" && item.id_foreign == data.id
    )[0];

    if (gambar) {
      try {
        var deleteFile = "";
        deleteFile = await axios.delete(Api.file + "/" + gambar.id);
      } catch (error) {}
    }
    goTo(0);
  };

  const columns = [
    {
      field: "nomor",
      headerName: "No",
      flex: 1,
      minWidth: 30,
    },

    {
      field: "kategori",
      headerName: "Kategori",
      flex: 2,
      minWidth: 100,
    },
    {
      field: "judul",
      headerName: "Wilayah",
      flex: 3,
      minWidth: 150,
    },
    {
      field: "penulis",
      headerName: "Penulis",
      flex: 3,
      minWidth: 150,
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 3,
      minWidth: 150,
      align: "center",
      renderCell: (params) => {
        const [open, SetOpen] = react.useState(false);

        const handleClickOpen = () => {
          SetOpen(true);
        };

        const handleClickClose = () => {
          SetOpen(false);
        };
        return (
          // <Button onClick={(e) => console.log(params.row)} variant="contained">
          //   Show
          // </Button>
          <Stack direction={"row"} spacing={1}>
            {/* <Dialog
              fullScreen
              open={open}
              onClose={handleClickClose}
              slots={{
                transition: Transition,
              }}
            >
              {" "}
              <AppBar sx={{ position: "fixed", bgcolor: "red" }}>
                <Toolbar>
                  <IconButton
                    edge="start"
                    color="inherit"
                    onClick={handleClickClose}
                    aria-label="close"
                  >
                    <CloseRounded fontSize="large" />
                  </IconButton>
                  <Typography
                    sx={{ ml: 2, flex: 1 }}
                    variant="h3"
                    align="center"
                    fontWeight={"bold"}
                    component="div"
                  >
                    {params.row.nama}
                  </Typography>
                </Toolbar>
              </AppBar>
              <Toolbar />
              <DetailDialog
                data={params.row}
                file={file.filter(
                  (item) =>
                    item.kategori == "Infrastruktur" &&
                    item.id_foreign == params.row.id
                )}
              />
            </Dialog>

            <Tooltip title="Tampilkan Detail Data">
              <IconButton onClick={handleClickOpen}>
                <SearchRounded color="info" />
              </IconButton>
            </Tooltip> */}

            <Tooltip title="Edit Data">
              <IconButton
                onClick={(e) =>
                  goTo("/daerah-form", {
                    state: {
                      data: params.row,
                      lastProfil: file.filter(
                        (item) =>
                          item.kategori == "Profil" &&
                          item.id_foreign == params.row.id
                      )[0],
                      lastGambar: file.filter(
                        (item) =>
                          item.kategori == "Gambar" &&
                          item.id_foreign == params.row.id
                      )[0],
                    },
                  })
                }
              >
                <EditRounded color="warning" />
              </IconButton>
            </Tooltip>

            <Tooltip title="Hapus Data">
              <IconButton
                onClick={(e) => {
                  deletePost(params.row);
                }}
              >
                <DeleteRounded color="error" />
              </IconButton>
            </Tooltip>
          </Stack>
        );
      },
    },
  ];
  // const row = [
  //   {
  //     id: 1001,
  //     kategori: "Kecamatan",
  //     value: "Basarang",
  //     label: "Kecamatan Basarang",
  //   },
  //   {
  //     id: 1002,
  //     kategori: "Kecamatan",
  //     value: "Bataguh",
  //     label: "Kecamatan Bataguh",
  //   },
  //   {
  //     id: 1003,
  //     kategori: "Kecamatan",
  //     value: "Dahadup",
  //     label: "Kecamatan Dahadup",
  //   },
  //   {
  //     id: 1004,
  //     kategori: "Kecamatan",
  //     value: "Kapuas Barat",
  //     label: "Kecamatan Kapuas Barat",
  //   },
  //   {
  //     id: 1005,
  //     kategori: "Kecamatan",
  //     value: "Kapuas Hilir",
  //     label: "Kecamatan Kapuas Hilir",
  //   },
  //   {
  //     id: 1006,
  //     kategori: "Kecamatan",
  //     value: "Kapuas Hulu",
  //     label: "Kecamatan Kapuas Hulu",
  //   },
  //   {
  //     id: 1007,
  //     kategori: "Kecamatan",
  //     value: "Kapuas Kuala",
  //     label: "Kecamatan Kapuas Kuala",
  //   },
  //   {
  //     id: 1008,
  //     kategori: "Kecamatan",
  //     value: "Kapuas Murung",
  //     label: "Kecamatan Kapuas Murung",
  //   },
  //   {
  //     id: 1009,
  //     kategori: "Kecamatan",
  //     value: "Kapuas Tengah",
  //     label: "Kecamatan Kapuas Tengah",
  //   },
  //   {
  //     id: 10010,
  //     kategori: "Kecamatan",
  //     value: "Kapuas Timur",
  //     label: "Kecamatan Kapuas Timur",
  //   },
  //   {
  //     id: 10011,
  //     kategori: "Kecamatan",
  //     value: "Mandau Talawang",
  //     label: "Kecamatan Mandau Talawang",
  //   },
  //   {
  //     id: 10012,
  //     kategori: "Kecamatan",
  //     value: "Mantangai",
  //     label: "Kecamatan Mantangai",
  //   },
  //   {
  //     id: 10013,
  //     kategori: "Kecamatan",
  //     value: "Pasak Talawang",
  //     label: "Kecamatan Pasak Talawang",
  //   },
  //   {
  //     id: 10014,
  //     kategori: "Kecamatan",
  //     value: "Pulau Petak",
  //     label: "Kecamatan Pulau Petak",
  //   },
  //   {
  //     id: 10015,
  //     kategori: "Kecamatan",
  //     value: "Selat",
  //     label: "Kecamatan Selat",
  //   },
  //   {
  //     id: 10016,
  //     kategori: "Kecamatan",
  //     value: "Tamban Catur",
  //     label: "TKecamatan amban Catur",
  //   },
  //   {
  //     id: 10017,
  //     kategori: "Kecamatan",
  //     value: "Timpah",
  //     label: "Kecamatan Timpah",
  //   },
  // ];

  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        padding: 0,
        bgcolor: "#E1E1E1",
      }}
    >
      <AppBarCustom selected="Artikel Kecamatan" />
      {/* <Toolbar sx={{ padding: 10 }} /> */}

      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <DrawerHeader theme={theme} />
        <Typography
          variant="h4"
          sx={{ fontWeight: "bold", marginBottom: 2 }}
          align="left"
        >
          Artikel Kecamatan
        </Typography>

        <Box padding={2} bgcolor={"white"} borderRadius={4}>
          {deleteStatus && (
            <Typography
              variant="body2"
              color="error.main"
              sx={{ display: "flex", alignItems: "center" }}
            >
              <DeleteRounded sx={{ ml: 1 }} /> {deleteStatus}
            </Typography>
          )}
          <TableCustom
            height={800}
            column={columns}
            row={row.map((item, index) => ({
              nomor: index + 1,
              ...item,
            }))}
          />
        </Box>
      </Box>
    </Box>
  );
}
const Transition = react.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
